<div class="back-button d-flex align-items-center" [routerLink]="url">
    <mat-icon class="back-button-icon">arrow_back</mat-icon>
    Back to {{ component }}
</div>